import { LoadingScreen } from "components/LoadingScreen";
import { IFiltrosAguardandoPagamento } from "../../../interface/IFiltrosAguardandoPagamento";
import { FiltrosAguardando } from "./containers/FiltrosAguardando";
import { ListarAguardando } from "./containers/ListarAguardando";
import { ModalCertezaAprovarLote } from "./containers/ModalCertezaAprovarLote";
import { ModalCertezaReprovarLote } from "./containers/ModalCertezaReprovarLote";
import { ModalSucessoAprovarLote } from "./containers/ModalSucessoAprovarLote";
import { ModalSucessoReprovarLote } from "./containers/ModalSucessoReprovarLote";
import { ContainerFiltros } from "./style";
import { useProcessoFinanceiroAprovar } from "../../../hooks/useProcessoFinanceiroAprovar";
import { useEffect, useState } from "react";
import { toastErro } from "components/Toast";
import { IEditarProcesso } from "../../../interface/IEditarProcesso";
import { IAtualizarLote } from "../../../interface/IAtualizarLote";

interface IProps {
  aba: string;
  setShowModalCriarLote: (show: boolean) => void;
}

export function TabAguardandoAprovacao({ aba, setShowModalCriarLote }: IProps) {
  const {
    dados,
    totalRows,
    limit,
    page,
    loading,
    filtro,
    setLimit,
    setPage,
    listar,
    selectedRows,
    setSelectedRows,
    aprovarLotes,
    reprovarLotes,
    idLoteEscolhido,
    setIdLoteEscolhido,
    dadosDetalhes,
    setDadosDetalhes,
    buscarDetalhesLotePagamento,
    buscarEstatisticasLotePagamento,
    buscarEstatisticasPagamento,
    onClickProcesso,
    relatorioDetalhado,
    relatorioResumido,
    numeroNfReciboEscolhido,
    buscarReciboNf,
    clearRows,
    idLoteCorrigir,
    setIdLoteCorrigir,
    selectedRowsCorrigir,
    setSelectedRowsCorrigir,
    removerProcessosLote,
    editarProcessoFinanceiroAprovar,
    atualizarLoteProcessoFinanceiroAprovar,
  } = useProcessoFinanceiroAprovar();
  function handlePageChange(page: number) {
    setPage(page);
  }
  function handleLimitChange(limit: number) {
    setLimit(limit);
  }
  const [showModalCertezaAprovarLote, setShowModalCertezaAprovarLote] =
    useState<boolean>(false);
  const [showModalCertezaReprovarLote, setShowModalCertezaReprovarLote] =
    useState<boolean>(false);
  const [showModalSucessoAprovarLote, setShowModalSucessoAprovarLote] =
    useState<boolean>(false);
  const [showModalSucessoReprovarLote, setShowModalSucessoReprovarLote] =
    useState<boolean>(false);
  const [showModalDetalhesLotePagamento, setShowModalDetalhesLotePagamento] =
    useState<boolean>(false);
  const [valorTotalLoteEscolhido, setValorTotalLoteEscolhido] = useState<
    number | null
  >(null);
  const [
    showModalDetalhesLotePagamentoCorrigir,
    setShowModalDetalhesLotePagamentoCorrigir,
  ] = useState<boolean>(false);
  const [valorTotalLoteCorrigir, setValorTotalLoteCorrigir] = useState<
    number | null
  >(null);

  useEffect(() => {
    if (aba !== "aguardando") return;

    listar();
  }, [aba, limit, page, filtro]);

  const submitFiltro = (dados: IFiltrosAguardandoPagamento) => {
    listar(dados);
  };

  const handleCloseModalCertezaAprovarLote = () => {
    setShowModalCertezaAprovarLote(false);
  };
  const handleCloseModalCertezaReprovarLote = () => {
    setShowModalCertezaReprovarLote(false);
  };
  const handleCloseModalSucessoAprovarLote = () => {
    setShowModalSucessoAprovarLote(false);
  };
  const handleCloseModalSucessoReprovarLote = () => {
    setShowModalSucessoReprovarLote(false);
  };

  const onConfirmModalCertezaAprovarLote = async () => {
    const { hasErro } = await aprovarLotes();
    if (!hasErro) {
      setShowModalCertezaAprovarLote(false);
      listar();
    }
  };
  const onConfirmModalCertezaReprovarLote = async () => {
    const { hasErro } = await reprovarLotes();
    if (!hasErro) {
      setShowModalCertezaReprovarLote(false);
      listar();
    }
  };

  const onClickModalAprovar = () => {
    if (!selectedRows.length) {
      toastErro("É necessário selecionar um lote ou mais.");
      return;
    }

    setShowModalCertezaAprovarLote(true);
  };

  const onClickModalReprovar = () => {
    if (!selectedRows.length) {
      toastErro("É necessário selecionar um lote ou mais.");
      return;
    }

    setShowModalCertezaReprovarLote(true);
  };

  const handleCloseModalDetalhes = () => {
    setShowModalDetalhesLotePagamento(false);
    setDadosDetalhes([]);
    setIdLoteEscolhido(null);
    setValorTotalLoteEscolhido(null);
  };

  const onClickVerDetalhes = (idLote: number) => {
    setIdLoteEscolhido(idLote);
    setValorTotalLoteEscolhido(
      dados.find((item) => item.id == idLote)?.valorNfRecibo ?? null,
    );
  };

  useEffect(() => {
    if (idLoteEscolhido) {
      buscarDetalhesLotePagamento();
      setShowModalDetalhesLotePagamento(true);
      return;
    }
  }, [idLoteEscolhido]);

  const onClickVerReciboNf = (idLote: number, numeroNfRecibo: string) => {
    buscarReciboNf(idLote, numeroNfRecibo);
    return;
  };

  const [processosAlterar, setProcessosAlterar] = useState<IEditarProcesso[]>(
    [],
  );
  const [dadosEditarProcesso, setDadosEditarProcesso] =
    useState<IEditarProcesso | null>(null);
  const [dadosAtualizarLote, setDadosAtualizarLote] =
    useState<IAtualizarLote | null>(null);

  const handleCloseModalCorrigir = () => {
    setShowModalDetalhesLotePagamentoCorrigir(false);
    setDadosDetalhes([]);
    setIdLoteCorrigir(null);
    setProcessosAlterar([]);
    setDadosEditarProcesso(null);
    setDadosAtualizarLote(null);
  };

  const onClickVerDetalhesCorrigir = (idLote: number) => {
    setIdLoteCorrigir(idLote);
    setValorTotalLoteCorrigir(
      dados.find((item) => item.id == idLote)?.valorNfRecibo ?? null,
    );
  };

  useEffect(() => {
    if (idLoteCorrigir) {
      buscarDetalhesLotePagamento();
      setShowModalDetalhesLotePagamentoCorrigir(true);
      return;
    }
  }, [idLoteCorrigir]);

  const [
    showModalCertezaRemoverProcessos,
    setShowModalCertezaRemoverProcessos,
  ] = useState<boolean>(false);
  const [
    showModalSucessoRemoverProcessos,
    setShowModalSucessoRemoverProcessos,
  ] = useState<boolean>(false);

  const onConfirmRemoverModalDetalhesLotePagamentoCorrigir = () => {
    setShowModalDetalhesLotePagamentoCorrigir(false);
    setShowModalCertezaRemoverProcessos(true);
  };
  const handleCloseModalCertezaRemoverProcessos = () => {
    setShowModalCertezaRemoverProcessos(false);
    setShowModalDetalhesLotePagamentoCorrigir(true);
  };
  const onConfirmModalCertezaRemoverProcessos = async () => {
    if (!idLoteCorrigir) {
      return;
    }

    const { hasErro } = await removerProcessosLote(idLoteCorrigir);

    if (!hasErro) {
      setProcessosAlterar(
        [...processosAlterar].filter(
          (processo) =>
            !selectedRowsCorrigir.some(
              (row) =>
                row.idProcessoFinanceiroAprovar ===
                processo.idProcessoFinanceiroAprovar,
            ),
        ),
      );
      setShowModalCertezaRemoverProcessos(false);
      setShowModalSucessoRemoverProcessos(true);
      listar(filtro);
    }
  };
  const handleCloseModalSucessoRemoverProcessos = () => {
    setShowModalSucessoRemoverProcessos(false);

    if (processosAlterar.length) {
      setDadosDetalhes(
        [...dadosDetalhes].filter(
          (processo) =>
            !selectedRowsCorrigir.some(
              (row) => row.idProcesso === processo.idProcesso,
            ),
        ),
      );
      setShowModalDetalhesLotePagamentoCorrigir(true);
      return;
    }

    setIdLoteCorrigir(null);
    setDadosDetalhes([]);
  };

  const [showModalEditarProcesso, setShowModalEditarProcesso] =
    useState<boolean>(false);
  const [
    showModalEditarProcessoNfReciboValores,
    setShowModalEditarProcessoNfReciboValores,
  ] = useState<boolean>(false);
  const [showModalSucessoEditarProcessos, setShowModalSucessoEditarProcessos] =
    useState<boolean>(false);

  const abrirModalEditarProcesso = (idProcessoFinanceiroAprovar: number) => {
    const processo = dadosDetalhes.filter(
      (processo) =>
        processo.idProcessoFinanceiroAprovar == idProcessoFinanceiroAprovar,
    );

    if (!processo.length) {
      toastErro("Dados não encontrados para este processo");
      return;
    }

    setDadosEditarProcesso({
      idProcessoFinanceiroAprovar,
      servicoAntes: processo[0].idDescricao,
      servicoDepois: processo[0].idDescricao,
      valorAntes: processo[0].valor ?? 0,
      valorDepois: processo[0].valor ?? 0,
      nomeServicoAntes: processo[0].descricao ?? "",
      nomeServicoDepois: processo[0].descricao ?? "",
    });
    setShowModalDetalhesLotePagamentoCorrigir(false);
    setShowModalEditarProcesso(true);
  };
  const handleCloseModalEditarProcesso = () => {
    setDadosEditarProcesso(null);
    setShowModalEditarProcesso(false);
    setShowModalDetalhesLotePagamentoCorrigir(true);
    setDadosAtualizarLote(null);
  };
  const onSubmitModalEditarProcesso = () => {
    if (
      dadosEditarProcesso &&
      (dadosEditarProcesso.servicoAntes != dadosEditarProcesso.servicoDepois ||
        dadosEditarProcesso.valorAntes != dadosEditarProcesso.valorDepois ||
        dadosEditarProcesso.nomeServicoAntes !=
          dadosEditarProcesso.nomeServicoDepois)
    ) {
      const novoProcessosAlterar = [...processosAlterar];
      novoProcessosAlterar.push(dadosEditarProcesso);
      setProcessosAlterar(novoProcessosAlterar);
    }
    setShowModalEditarProcesso(false);
    setShowModalDetalhesLotePagamentoCorrigir(true);
    setDadosDetalhes(
      [...dadosDetalhes].map((detalhe) => {
        if (
          detalhe.idProcessoFinanceiroAprovar !=
          dadosEditarProcesso?.idProcessoFinanceiroAprovar
        ) {
          return detalhe;
        }
        return {
          ...detalhe,
          valor: dadosEditarProcesso?.valorDepois ?? 0,
          idDescricao: dadosEditarProcesso.servicoDepois,
          descricao: dadosEditarProcesso.nomeServicoDepois,
        };
      }),
    );
  };
  const handleEditarProcesso = async () => {
    let comErro = false;

    await Promise.all(
      processosAlterar.map(async (processo) => {
        const { hasErro, data } =
          await editarProcessoFinanceiroAprovar(processo);
        if (hasErro) {
          comErro = true;

          toastErro(data.message ?? `Não foi possível atualizar o processo`);
          return;
        }

        setProcessosAlterar(
          [...processosAlterar].filter(
            (proc) =>
              proc.idProcessoFinanceiroAprovar ===
              processo.idProcessoFinanceiroAprovar,
          ),
        );
      }),
    );

    if (comErro) {
      return false;
    }

    setProcessosAlterar([]);
    setDadosEditarProcesso(null);
    return true;
  };
  const onConfirmSalvarModalDetalhesLotePagamentoCorrigir = async () => {
    setShowModalDetalhesLotePagamentoCorrigir(false);

    if (
      processosAlterar.some(
        (processo) => processo.valorAntes != processo.valorDepois,
      )
    ) {
      if (!idLoteCorrigir) {
        return;
      }

      setDadosAtualizarLote({
        idLote: idLoteCorrigir,
        arquivo: null,
        valorNfRecibo: valorTotalLoteCorrigir ?? 0,
        numeroNfRecibo:
          dados.find((item) => item.id == idLoteCorrigir)?.numeroNfRecibo ?? "",
      });
      setShowModalEditarProcessoNfReciboValores(true);
      return;
    }

    if (!(await handleEditarProcesso())) {
      return;
    }

    setShowModalSucessoEditarProcessos(true);
    setDadosAtualizarLote(null);
    handleCloseModalCorrigir();
    listar(filtro);
  };
  const handleCloseModalEditarProcessoNfReciboValores = () => {
    setShowModalEditarProcessoNfReciboValores(false);
    setShowModalDetalhesLotePagamentoCorrigir(true);
  };
  const onConfirmModalEditarProcessoNfReciboValores = async () => {
    if (!(await handleEditarProcesso()) || !dadosAtualizarLote) {
      return;
    }

    const { hasErro, data } =
      await atualizarLoteProcessoFinanceiroAprovar(dadosAtualizarLote);

    if (hasErro) {
      toastErro(data.message ?? "Erro ao atualizar o lote");
      return;
    }

    setShowModalEditarProcessoNfReciboValores(false);
    setShowModalSucessoEditarProcessos(true);
    setDadosAtualizarLote(null);
    handleCloseModalCorrigir();
    listar(filtro);
  };
  const handleCloseModalSucessoEditarProcessos = () => {
    setShowModalSucessoEditarProcessos(false);
  };

  return (
    <ContainerFiltros>
      <LoadingScreen mostrar={loading} />
      <FiltrosAguardando submitForm={submitFiltro} />
      <ListarAguardando
        dados={dados}
        handleLimitChange={handleLimitChange}
        handlePageChange={handlePageChange}
        totalRows={totalRows}
        setRowsSelected={setSelectedRows}
        selectedRows={selectedRows}
        selectedRowsCorrigir={selectedRowsCorrigir}
        setSelectedRowsCorrigir={(row) => setSelectedRowsCorrigir(row)}
        loadingLista={false}
        linhasPorPagina={limit}
        onClickAprovar={onClickModalAprovar}
        onClickReprovar={onClickModalReprovar}
        showModalDetalhesLotePagamento={showModalDetalhesLotePagamento}
        dadosDetalhes={dadosDetalhes}
        handleCloseModalDetalhes={handleCloseModalDetalhes}
        numeroNfReciboEscolhido={numeroNfReciboEscolhido}
        onClickVerDetalhes={onClickVerDetalhes}
        buscarEstatisticasLotePagamento={buscarEstatisticasLotePagamento}
        buscarEstatisticasPagamento={buscarEstatisticasPagamento}
        valorTotalLoteEscolhido={valorTotalLoteEscolhido}
        onClickProcesso={onClickProcesso}
        relatorioDetalhado={relatorioDetalhado}
        relatorioResumido={relatorioResumido}
        onClickVerReciboNf={onClickVerReciboNf}
        clearRows={clearRows}
        setShowModalCriarLote={setShowModalCriarLote}
        showModalDetalhesLotePagamentoCorrigir={
          showModalDetalhesLotePagamentoCorrigir
        }
        handleCloseModalCorrigir={handleCloseModalCorrigir}
        onClickVerDetalhesCorrigir={onClickVerDetalhesCorrigir}
        handleCloseModalCertezaRemoverProcessos={
          handleCloseModalCertezaRemoverProcessos
        }
        onConfirmModalCertezaRemoverProcessos={
          onConfirmModalCertezaRemoverProcessos
        }
        handleCloseModalEditarProcesso={handleCloseModalEditarProcesso}
        onSubmitModalEditarProcesso={onSubmitModalEditarProcesso}
        handleCloseModalEditarProcessoNfReciboValores={
          handleCloseModalEditarProcessoNfReciboValores
        }
        handleCloseModalSucessoEditarProcessos={
          handleCloseModalSucessoEditarProcessos
        }
        handleCloseModalSucessoRemoverProcessos={
          handleCloseModalSucessoRemoverProcessos
        }
        showModalCertezaRemoverProcessos={showModalCertezaRemoverProcessos}
        showModalSucessoRemoverProcessos={showModalSucessoRemoverProcessos}
        showModalEditarProcesso={showModalEditarProcesso}
        showModalEditarProcessoNfReciboValores={
          showModalEditarProcessoNfReciboValores
        }
        showModalSucessoEditarProcessos={showModalSucessoEditarProcessos}
        onConfirmRemoverModalDetalhesLotePagamentoCorrigir={
          onConfirmRemoverModalDetalhesLotePagamentoCorrigir
        }
        onConfirmSalvarModalDetalhesLotePagamentoCorrigir={
          onConfirmSalvarModalDetalhesLotePagamentoCorrigir
        }
        onConfirmModalEditarProcessoNfReciboValores={
          onConfirmModalEditarProcessoNfReciboValores
        }
        abrirModalEditarProcesso={abrirModalEditarProcesso}
        dadosEditarProcesso={dadosEditarProcesso}
        setDadosEditarProcesso={setDadosEditarProcesso}
        dadosAtualizarLote={dadosAtualizarLote}
        setDadosAtualizarLote={setDadosAtualizarLote}
        idLoteCorrigir={idLoteCorrigir}
        processosAlterar={processosAlterar}
        valorTotalLoteCorrigir={valorTotalLoteCorrigir}
        aba={aba}
      />
      <ModalCertezaAprovarLote
        show={showModalCertezaAprovarLote}
        handleClose={handleCloseModalCertezaAprovarLote}
        onConfirm={onConfirmModalCertezaAprovarLote}
      />
      <ModalCertezaReprovarLote
        show={showModalCertezaReprovarLote}
        handleClose={handleCloseModalCertezaReprovarLote}
        onConfirm={onConfirmModalCertezaReprovarLote}
      />
      <ModalSucessoAprovarLote
        show={showModalSucessoAprovarLote}
        handleClose={handleCloseModalSucessoAprovarLote}
      />
      <ModalSucessoReprovarLote
        show={showModalSucessoReprovarLote}
        handleClose={handleCloseModalSucessoReprovarLote}
      />
    </ContainerFiltros>
  );
}
